import { useState, useEffect } from "react";
import { IonRow, IonCol } from "@ionic/react";
import { Loading, SEO, PageTitle } from "../components";
import { useGigData } from "../hooks/useGigData";
import { sortByDate } from "../helpers/helpers";

export const Gigs = (props) => {
  const { config, project } = props;
  const [loading, setLoading] = useState(true);
  const [isPastEventsCollapsed, setIsPastEventsCollapsed] = useState(true);
  const sheetId = config?.googleSheetId;
  const seo = config?.SEO.gigs;

  const data = useGigData(sheetId);
  const sortedGigs = sortByDate(data);
  const upcomingGigs = sortedGigs.filter(
    (gig) => new Date(gig.date) >= new Date()
  );
  const pastGigs = sortedGigs.filter((gig) => new Date(gig.date) < new Date());

  const festivals = pastGigs.filter((gig) => gig.type === "festival");
  const parties = pastGigs.filter((gig) => gig.type === "party");
  const radioShows = pastGigs.filter((gig) => gig.type === "radio");

  const togglePastEventsVisibility = () => {
    setIsPastEventsCollapsed((prevState) => !prevState);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setLoading(false);
    }
  }, [data]);

  return (
    <div id="GigsPage" className="gigs-page no-select">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />
      {loading ? (
        <Loading />
      ) : (
        <div className="gigs-box ">
          <EventRow pageTitle={"UPCOMING EVENTS"} data={upcomingGigs} />
          &nbsp;
          <PageTitle
            pageTitle={"PAST EVENTS"}
            onClick={togglePastEventsVisibility}
            className="page-title-clickable"
          />
          {!isPastEventsCollapsed && (
            <>
              <EventRow pageTitle={"FESTIVALS"} data={festivals} />
              <EventRow pageTitle={"PARTIES"} data={parties} />
              <EventRow pageTitle={"RADIO SHOWS"} data={radioShows} />
            </>
          )}
        </div>
      )}
    </div>
  );
};

const EventRow = (props) => {
  const { pageTitle, data } = props;

  return (
    <div>
      <PageTitle pageTitle={pageTitle} />
      {data.map((gig, idx) => (
        <IonRow key={idx} className="gig-row transparent-frame">
          <IonCol size="3">
            {new Date(gig.date).toLocaleDateString("en-GB")}
          </IonCol>
          <IonCol size="6">
            <a
              href={gig.link}
              className="gig-link"
              target="_blank"
              rel="noreferrer"
            >
              {gig.name}
            </a>
          </IonCol>
          {/* <IonCol size="1">
            <a
              href={gig.link}
              className="gig-link"
              target="_blank"
              rel="noreferrer"
            >
              {gig.link && <FaExternalLinkAlt />}
            </a>
          </IonCol> */}
          <IonCol size="3">{gig.country}</IonCol>
        </IonRow>
      ))}
    </div>
  );
};
